export default "query PageByHandle($handle: String!) {\n    pageByHandle(handle: $handle) {\n          body\n          title\n    }   \n}";